import React, { useEffect } from "react";

const BLOG_URL = "https://blog.sassyfitness.com";

// The blog now lives at blog.sassyfitness.com (static Astro site on Cloudflare).
// Any legacy /blog visits are forwarded there.
const BlogPage = () => {
  useEffect(() => {
    window.location.replace(BLOG_URL);
  }, []);

  return (
    <div
      className="bg-background min-h-screen flex items-center justify-center px-[5%] text-center"
      data-testid="blog-redirect"
    >
      <p className="text-white/70 text-lg">
        Taking you to the blog&hellip;{" "}
        <a href={BLOG_URL} className="text-primary underline font-semibold">
          Click here
        </a>{" "}
        if you&rsquo;re not redirected.
      </p>
    </div>
  );
};

export default BlogPage;
